import { render, staticRenderFns } from "./CustomFiveCoulumnTable.vue?vue&type=template&id=2384eb58&scoped=true&"
import script from "./CustomFiveCoulumnTable.vue?vue&type=script&lang=js&"
export * from "./CustomFiveCoulumnTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomFiveCoulumnTable.vue?vue&type=style&index=0&id=2384eb58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384eb58",
  null
  
)

export default component.exports